class BlockKeyNumbers {
	constructor() {
		this.blocks = document.querySelectorAll(".block-key-numbers .number");

		if (!this.blocks) {
			return;
		}

		this.buildNumberAnims();
	}

	buildNumberAnims() {
		this.blocks.forEach(block => {
			this.textAnim(block);
			ScrollTrigger.create({
				trigger: block,
				start: "top 90%",
				once: true,
				onEnter: () => {
					block.tlChars.play(0);
				}
			});
		});

	}

	textAnim(elem) {
		this.splitNumber = new SplitText(elem, {type: "chars, words", charsClass: "char"});

		gsap.ticker.lagSmoothing(false);
		elem.tlChars = gsap.timeline();

		const yValues = [-20, -10, 10, 20];

		elem.tlChars.pause();
		elem.tlChars.fromTo(
			this.splitNumber.chars, {
				autoAlpha: 0,
				yPercent: 20,
			}, {
				autoAlpha: 1,
				yPercent: 0,
				ease: "Power1.easeOut",
				stagger: {
					each: 0.1,
					from: "random"
				},
				duration: 0.8
			});

		gsap.set(this.splitNumber.chars, {
			opacity: 0
		});

		gsap.set(this.splitNumber.chars, {
			opacity: 0
		});
	}
}
